module.exports = __webpack_public_path__ + "static/media/header-960.8a676b5e.webp";